module.exports = __webpack_public_path__ + "img/user_information_print.887e35d1.png";